import { useState } from 'react';
import { connect } from 'react-redux';

let _content = null;

const Agreement = (props) => {
  const [infoModal, setInfoModal] = useState(false);
  const [salesModal, setSalesModal] = useState(false);
  const [userAgreementModal, setUserAgreementModal] = useState(false);
  const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false);

  const [twoStepAggrement, setTwoStepAggrement] = useState([true, true]);

  const handleCheckboxChange = (e, index) => {
    const newTwoStepAggrement = [...twoStepAggrement];
    newTwoStepAggrement[index] = !newTwoStepAggrement[index];
    setTwoStepAggrement(newTwoStepAggrement);
  };

  const openModal = (modalName) => {
    if (modalName === 'infoModal') {
      setInfoModal(true);
    }
    if (modalName === 'salesModal') {
      setSalesModal(true);
    }
    if (modalName === 'userAgreementModal') {
      setUserAgreementModal(true);
    }
    if (modalName === 'privacyPolicyModal') {
      setPrivacyPolicyModal(true);
    }
  };

  const closeModal = () => {
    setInfoModal(false);
    setSalesModal(false);
    setUserAgreementModal(false);
    setPrivacyPolicyModal(false);
  };

  return (
    _content &&
    _content({
      props,
      infoModal,
      salesModal,
      userAgreementModal,
      privacyPolicyModal,
      openModal,
      closeModal,
      twoStepAggrement,
      handleCheckboxChange,
    })
  );
};

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(Agreement);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/checkout/agreement/index.js